export default __webpack_public_path__ + "static/media/cif-tr.8e255e44.svg";